var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('router-view'),_c('div',{staticClass:"info_block_wrapper"},[_c('router-view',{attrs:{"name":"order"}}),_c('router-view',{attrs:{"name":"delivery"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }